<!-- include form  -->
<form class="mt-4" [formGroup]="form">
    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full  flex justify-between">

                    <mat-panel-title class="font-bold">
                        Include target
                    </mat-panel-title>

                    <div class="">
                        <sway-baseline-status
                            [hasError]="!policy?.id || errorsString.includes('/includeTargets')"></sway-baseline-status>

                    </div>

                </div>

            </mat-expansion-panel-header>

            <div>
                <mat-error *ngIf="!includeTargetsValue?.includedGroups?.length ">
                    The policy must be included in at least one included group
                </mat-error>

                <table>
                    <thead>
                        <tr>
                            <th>
                                Field
                            </th>

                            <th>
                                Current Value
                            </th>

                            <th>
                                Desired Value
                            </th>

                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>
                                Included groups
                            </td>


                            <td>



                                <div>

                                    <div *ngIf="policy?.includeTargets?.length > 0" class="font-bold mt-2">
                                        <table class="child-table mat-elevation-z2">
                                            <thead>
                                                <tr>
                                                    <th class="child-cell">Group</th>

                                                    <!-- Dynamic Column Headers -->
                                                    <ng-container *ngIf="includeOptionsLookups?.length > 0">

                                                        <th class="child-cell"
                                                            *ngFor="let column of includeOptionsLookups">
                                                            {{ column.name }}
                                                        </th>
                                                    </ng-container>

                                                    <!-- Use for Sign-in Column Header -->
                                                    <th class="child-cell" *ngIf="showIsUsableForSignIn">
                                                        Use for Sign-in
                                                    </th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr *ngFor="let group of policy?.includeTargets; let i = index">
                                                    <td class="child-cell">
                                                        <div *ngIf="group?.id === 'all_users'">
                                                            All users
                                                        </div>


                                                        <div *ngIf="group?.id !== 'all_users'">

                                                            {{ groups.get(group.id)?.displayName || 'Unknown Group' }}
                                                        </div>
                                                    </td>

                                                    <td *ngIf="includeOptionsLookups?.length > 0" class="child-cell">
                                                        {{ group?.authenticationMode ? includeOptionValues[group.authenticationMode] : '-' }}
                                                    </td>

                                                    <td *ngIf="showIsUsableForSignIn" class="child-cell">
                                                        <mat-checkbox [checked]="group?.isUsableForSignIn || false" [disabled]="true">
                                                        </mat-checkbox>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>

                            </td>


                            <td formGroupName="includeTargets">

                                <mat-radio-group (change)="onChangeIncludedTargets()" formControlName="groupInclusion">
                                    <mat-radio-button [value]="false">
                                        All users</mat-radio-button>
                                    <mat-radio-button [value]="true"> Select Groups</mat-radio-button>

                                </mat-radio-group>


                                <div>
                                    <div formArrayName="includedGroups">
                                        <div *ngIf="includeTargetsValue?.includedGroups?.length > 0"
                                            class="mt-2 font-bold">
                                            <table class="child-table mat-elevation-z2">
                                                <thead>
                                                    <tr>
                                                        <th class="child-cell">Group</th>

                                                        <!-- Dynamic Column Headers -->

                                                        <ng-container *ngIf="includeOptionsLookups?.length > 0">

                                                            <th class="child-cell"
                                                                *ngFor="let column of includeOptionsLookups">
                                                                {{ column.name }}
                                                            </th>
                                                        </ng-container>

                                                        <!-- Use for Sign-in Column Header -->
                                                        <th class="child-cell" *ngIf="showIsUsableForSignIn">
                                                            Use for Sign-in
                                                        </th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr *ngFor="let group of form.get('includeTargets')?.get('includedGroups')?.value; let i = index;trackBy: trackByGroupId"
                                                        [formGroupName]="i">
                                                        <td class="child-cell">
                                                            <div *ngIf="group?.id === 'all_users'">

                                                                All users
                                                            </div>

                                                            <div *ngIf="group?.id !== 'all_users'">

                                                                {{ groups.get(group.id)?.displayName || 'Unknown Group'
                                                                }}
                                                            </div>
                                                        </td>

                                                        <td *ngIf="includeOptionsLookups?.length > 0" class="child-cell">

                                                                <ng-container
                                                                    *ngFor="let column of includeOptionsLookups">


                                                                    <ng-select [readonly]="readOnly && !item?.override?.includes('includeTargets')" [appendTo]="'body'" [clearable]="false"
                                                                        [formControlName]="column.key">
                                                                        <!-- should be generic  -->
                                                                        <ng-option
                                                                            *ngFor="let option of column.options; trackBy: trackByColumnKey"
                                                                            [value]="option.value">
                                                                            {{ option.label }}
                                                                        </ng-option>
                                                                    </ng-select>
                                                                </ng-container>

                                                        </td>

                                                        <td *ngIf="showIsUsableForSignIn" class="child-cell">
                                                            <mat-checkbox formControlName="isUsableForSignIn" [disabled]="readOnly && !item?.override?.includes('includeTargets')">
                                                            </mat-checkbox>
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>

                                        </div>

                                        <ng-container *ngIf="form.get('includeTargets')?.get('groupInclusion').value === true ">

                                            <div *ngIf="!item || (item.override?.includes('includeTargets'))" class="mt-3">
                                                <button class="" (click)="manageGroups('Include')" color='primary'
                                                mat-button>Manage</button>
                                            </div>
                                        </ng-container>

                                    </div>
                                </div>

                            </td>

                            <td>
                                <sway-baseline-status
                                    [hasError]="!policy?.id || errorsString.includes('/includeTargets')"></sway-baseline-status>
                            </td>
                        </tr>



                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</form>


<!-- exclude form  -->
<form class="mt-4" [formGroup]="form">

    <mat-accordion>
        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <div class="items-center w-full  flex justify-between">

                    <mat-panel-title class="font-bold">
                        Exclude target
                    </mat-panel-title>

                    <div class="">
                        <sway-baseline-status
                            [hasError]="!policy?.id || errorsString.includes('/excludeTargets')"></sway-baseline-status>

                    </div>

                </div>

            </mat-expansion-panel-header>

            <div>

                <table>
                    <thead>
                        <tr>
                            <th>
                                Field
                            </th>

                            <th>
                                Current Value
                            </th>

                            <th>
                                Desired Value
                            </th>

                            <th>
                                Status
                            </th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr>
                            <td>
                                Excluded groups
                            </td>


                            <td>
                                <div class="font-bold mt-2">
                                    Policy has {{policy?.excludeTargets?.length}} excluded groups
                                </div>
                            </td>


                            <td formGroupName="excludeTargets">
                                <div>
                                    <div *ngIf="excludeTargetsValue?.length" class="mt-2 font-bold">
                                        Baseline has {{excludeTargetsValue.length}} excluded groups
                                    </div>

                                    <div *ngIf="!excludeTargetsValue?.length " class="mt-2 font-bold">
                                        No excluded groups. You can add excluded groups by clicking the 'Manage' button.
                                    </div>

                                    <button *ngIf="!item || (item.override?.includes('excludeTargets'))" (click)="manageGroups('Exclude')" color='primary' mat-button>Manage</button>
                                </div>
                            </td>

                            <td>
                                <sway-baseline-status
                                    [hasError]="!policy?.id || errorsString.includes('/excludeTargets')"></sway-baseline-status>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </mat-expansion-panel>
    </mat-accordion>
</form>
